import { render, staticRenderFns } from "./SettingsNavigation.vue?vue&type=template&id=8e74dae2&scoped=true"
import script from "./SettingsNavigation.vue?vue&type=script&lang=ts"
export * from "./SettingsNavigation.vue?vue&type=script&lang=ts"
import style0 from "./SettingsNavigation.vue?vue&type=style&index=0&id=8e74dae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e74dae2",
  null
  
)

export default component.exports